import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { BankMatchUiFlowValue, UiSourceValue } from '../enums'
import { unMatchBankLineMatch } from '../query-api'

interface UseUnmatchBankTransactionProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
  uiSource?: UiSourceValue
  uiFlow?: BankMatchUiFlowValue
}

export const useUnmatchBankTransaction = (props?: UseUnmatchBankTransactionProps) => {
  const { onError, onSuccess, uiSource, uiFlow } = props || {}

  const {
    mutate: unmatch,
    isLoading: isProcessing,
    ...rest
  } = useMutation((matchId: string) => unMatchBankLineMatch(matchId, uiSource, uiFlow), {
    onSuccess,
    onError,
  })

  return { unmatch, isProcessing, ...rest }
}
